import { render } from "./ShareTipDialog.vue?vue&type=template&id=ac310b10&scoped=true"
import script from "./ShareTipDialog.vue?vue&type=script&lang=js"
export * from "./ShareTipDialog.vue?vue&type=script&lang=js"

import "./ShareTipDialog.vue?vue&type=style&index=0&id=ac310b10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac310b10"]])

export default __exports__